import { useState } from 'react';
import { Link } from 'react-router-dom';
import { videos, type VideoItem } from '@/mocks/videos';

export default function FeaturedContent() {
  const [activeTab, setActiveTab] = useState('hot');
  const featured: VideoItem[] = activeTab === 'hot'
    ? videos.filter((v) => v.isHot).slice(0, 6)
    : videos.filter((v) => v.isNew).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">为您精心挑选的高品质影视内容</p>
          </div>
          <div className="flex bg-background-100 rounded-full p-1">
            <button
              onClick={() => setActiveTab('hot')}
              className={`px-5 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                activeTab === 'hot'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              热门推荐
            </button>
            <button
              onClick={() => setActiveTab('new')}
              className={`px-5 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                activeTab === 'new'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              最新上线
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  {video.isNew && (
                    <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded">
                      新
                    </span>
                  )}
                  {video.isHot && (
                    <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded">
                      热
                    </span>
                  )}
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded">
                  {video.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors text-sm">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{video.description}</p>
                <div className="flex items-center justify-between mt-3">
                  <div className="flex items-center gap-2 text-xs text-foreground-400">
                    <span>{video.year}</span>
                    <span>·</span>
                    <span>{video.region}</span>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-accent-500">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-[10px]"></i>
                    </span>
                    {video.rating}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}